// extracted by mini-css-extract-plugin
export var closeButton = "freelance-ads-module--closeButton--fcd8c";
export var freelanceAd = "freelance-ads-module--freelanceAd--fad2c";
export var text = "freelance-ads-module--text--5549a";